module.exports = __webpack_public_path__ + "img/wxico.8b972379.png";